module.exports = __webpack_public_path__ + "static/media/sleep-brochure-cover.d7879339.png";